import { render } from "./EditPayCurrency.vue?vue&type=template&id=7ec75cce"
import script from "./EditPayCurrency.vue?vue&type=script&lang=js"
export * from "./EditPayCurrency.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__